import "./Assessment.css";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actionCreators } from "../store/Assessment";
import LoginRequired from "./assessment/LoginRequired";
import PageHeader from "./assessment/PageHeader";
import PageContent from "./assessment/PageContent";

class Assessment extends Component {
    constructor(props) {
        super(props);
        const { key } = this.props.match.params;
        this.props.getCurrentStep(key);
    }

    render() {
        const p = this.props;

        if (p.step === 0) {
            return null;
        }

        if (p.loginRequired) {
            return (
<div className="test-page">
    <LoginRequired />
</div>
            );
        }

        const waitingForSpeech = p.hasSpeech && (p.speechPlaying || !p.speechPlayed);

        return (
<div className="test-page">
    <PageHeader step={p.step} unlocked={p.unlocked} allowDevMode={p.allowDevMode} devMode={p.devMode} allowTrainingMode={p.allowTrainingMode} trainingMode={p.trainingMode} speechSupported={p.speechSupported} hasSpeech={p.hasSpeech} playSpeech={p.playSpeech} speechPlaying={p.speechPlaying} speechPlayedCount={p.speechPlayedCount} tests={p.tests} cancelSpeech={p.cancelSpeech} volume={p.volume} setDevMode={p.setDevMode} setTrainingMode={p.setTrainingMode} jumpTo={p.jumpTo} unlock={p.unlock} setVolume={p.setVolume} />
    <PageContent step={p.step} currentTabId={p.currentTabId} devMode={p.devMode} trainingMode={p.trainingMode} volume={p.volume} setSpeech={p.setSpeech} playSpeechForInstructionEnd={p.playSpeechForInstructionEnd} waitingForSpeech={waitingForSpeech} cancelSpeech={p.cancelSpeech} next={p.next} previous={p.previous} setCurrentTab={p.setCurrentTab} verifyPassword={p.verifyPassword} />
</div>
        );
    }
}

export default connect(
    state => state.stepper,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Assessment);
